/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { parseNumber } from '@jalik/form-parser'
import FormNumberField, {
  FormNumberFieldProps
} from '../../../../client/js/components/form/fields/FormNumberField'

function TerraceAreaField (props: FormNumberFieldProps) {
  const { name = 'terraceArea', ...others } = props
  const intl = useIntl()
  return (
    <FormNumberField
      label={intl.formatMessage({
        id: 'terrace_area',
        defaultMessage: 'Superficie de la terrasse'
      })}
      name={name}
      parser={parseNumber}
      suffix={' m²'}
      {...others}
    />
  )
}

export default TerraceAreaField
